import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
var SvgWhiteInfo = props => _jsx("svg", _objectSpread(_objectSpread({
  width: 16,
  height: 16,
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), {}, {
  children: _jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 0a8 8 0 1 1 0 16A8 8 0 0 1 8 0Zm0 1a7 7 0 1 0 0 14A7 7 0 0 0 8 1Zm0 10a1 1 0 1 1 0 2 1 1 0 0 1 0-2Zm0-7.75a.75.75 0 0 1 .743.648L8.75 4v5a.75.75 0 0 1-1.493.102L7.25 9V4A.75.75 0 0 1 8 3.25Z",
    fill: "#FFF"
  })
}));
export default SvgWhiteInfo;